module.exports = "https://99designs-start-assets.imgix.net/js/053bbbf0b28e3c85cbc8b053ad5d7aa1.png";